import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { signUp_action } from '../../actions/user_login_auth_actions/user_login_auth_action';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { emailValidator, mobileNoValidator, nameValidator, passwordValidator } from '../../utils/Validator'
import $ from 'jquery'
import { getCurrentAwardDetails_action } from '../../actions/static_action/currentAwardDetails_action'
import moment from "moment";
import { toastError } from "../../utils/constants";
import { Modal } from "react-bootstrap";

class SignUp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userEmail: '',
            password: '',
            username: '', userPhone: '',
            is_showpass: false,
            isOpen: false,
            isLoading: false,
            companyInfo: false,
            isOpen2: false,
            CenterID: '',
            isCommingSoon: false,
            timeLeft: {},
            intervalId: null
        }
        // this.handleObscure = this.handleObscure.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.navigateLogIn = this.navigateLogIn.bind(this)
    }


    componentWillUnmount() {
        clearInterval(this.timer);
    }

    getCountDownDate(e) {
        this.setState({ isLoading: true })
        this.props.getCurrentAwardDetails_action(null)
            .then((data) => {
                if (data.error != 1) {
                    if (data.applicationDate != '') {

                        const LaunchDate = data.applicationDate[0]["launch_date"]
                        // const LaunchDate = '2025-02-20T18:08:00.000Z'
                        console.log(LaunchDate)
                        const targetDate = moment.utc(LaunchDate);  // Target in UTC

                        // Current date in UTC
                        const currentDate = moment();  // Current date in UTC
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        if (totalSeconds >= 0) {
                            const timer = setInterval(() => {
                                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                                    this.setState({ isOpen2: true, isLoading: false, isCommingSoon: false });
                                });
                            }, 1000);
                            this.setState({ intervalId: timer });
                        } else {
                            console.log('hit done')
                            this.setState({ isCommingSoon: true, isLoading: false, isOpen2: false }, () => this.handleSubmit(e));

                        }
                    } else {
                        this.handleSubmit()
                        this.setState({ isCommingSoon: true, isOpen2: false })
                    }

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    calculateTimeLeft = (LaunchDate) => {

        const targetDate = moment.utc(LaunchDate);
        const currentDate = moment();
        const split = currentDate.format().split('+')
        const updateCurrentDate = split[0] + 'Z'
        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
        console.log("totalSeconds--------->", totalSeconds)
        // Calculate the total minutes, hours, and days
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        console.log(days, hours, minutes, seconds, 'before time')
        if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
            console.log(days, hours, minutes, seconds, 'after time')
            this.setState({ isOpen2: false }, () => {
                console.log('state false', this.state.isOpen2)
                const { intervalId } = this.state;
                if (intervalId) {
                    clearInterval(intervalId); // Stop the timer
                    this.setState({ intervalId: null }); // Reset the interval ID
                }
                window.location.reload();
            })
        }
        return {
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
        };
    };

    jQuerycode = () => {
        // SLIDESHOW
        $(function () {
            $('#slideshow > div:gt(0)').hide();
            setInterval(function () {
                $('#slideshow > div:first')
                    .fadeOut(1000)
                    .next()
                    .fadeIn(1000)
                    .end()
                    .appendTo('#slideshow');
            }, 3850);
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { userEmail, username, password, userPhone } = this.state
        var errMsg = nameValidator(username)
        var errMsg2 = mobileNoValidator(userPhone.trim())
        var errMsg3 = emailValidator(userEmail)
        var errMsg4 = passwordValidator(password)
        console.log(errMsg, errMsg2, errMsg3, errMsg4, 'check')
        if (errMsg != '' || errMsg2 != '' || errMsg3 != '' || errMsg4 != '') {
            toast.error(errMsg != '' ? errMsg : errMsg2 != '' ? errMsg2 : errMsg3 != '' ? errMsg3 : errMsg4 != '' ? errMsg4 : '', {
                theme: 'colored',
                autoClose: errMsg != '' ? 1000 : errMsg2 != '' ? 1000 : errMsg3 != '' ? 1000 : errMsg4 != '' ? 9999 : '',
                hideProgressBar: true,
            })
        } else {
            if (username != '' && userPhone != '' && userEmail != '' && password != '') {
                // this.setState({ isLoading: true })
                this.props
                    .signUp_action(username, userPhone, userEmail, password)
                    .then((data) => {
                        if (data.error != 1) {
                            const award_event_profile_id = sessionStorage.getItem("award_event_profile_id")
                            console.log("award_event_profile_id--->", award_event_profile_id)
                            if (award_event_profile_id != null) {
                                this.props.navigate("/applicationForm");
                            } else {
                                this.props.navigate("/applicantDashboard");
                            }
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false }, () => {
                                toast.error(data.msg, {
                                    theme: 'colored',
                                    position: 'top-right',
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                })
                            })
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
            else {
                this.setState({ isLoading: false })

                toast.error('Please check user name and password', {
                    theme: 'colored',
                    autoClose: 1000,
                    hideProgressBar: true,
                })
            }
        }
    }

    componentDidMount() {
        this.jQuerycode()

        this.setState({
            companyInfo: this.props.location.state != null && this.props.location.state.companyInfo != null ? this.props.location.state.companyInfo : false,
            CenterID: this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : '',
        })

    }

    handleKeyDown(e) {
        if (e.code === 'Enter') {
            if (!this.state.isCommingSoon) {
                this.getCountDownDate(e)
            } else {
                this.handleSubmit(e)
            }
        }
    }


    navigateLogIn() {
        this.props.navigate('/login')
    }
    navigateWebsite() {
        this.props.navigate('/')
    }

    render() {
        const { userEmail, userPhone, password, isLoading, isOpen, username, email, is_showpass, is_forgotPassword, timeLeft } = this.state
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <div className="login-container">
                        <ToastContainer />
                        <div className="login-box">
                            <div className="form-section">
                                <marquee
                                    style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                                    behavior="scroll"
                                    direction="left"
                                    scrollamount="5"
                                    onMouseOver={(e) => e.target.stop()}
                                    onMouseOut={(e) => e.target.start()}
                                >
                                   <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                                </marquee>
                                <img src="img/logo.png" alt="Logo" className="logo" />
                                <h2>Welcome</h2>
                                {/* <p>Continue your journey with ITME</p> */}
                                <input type="text" placeholder="Name" className="input-field" value={username}
                                    onChange={(e) => this.setState({
                                        username: e.target.value.split(' ')
                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                            .join(' ')
                                    })}
                                    onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={70}
                                />
                                <input type="text" placeholder="Contact No" className="input-field" value={userPhone}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const phoneRegex = /^[0-9]{0,20}$/; // allow only up to 20 digits

                                        if (value === "" || phoneRegex.test(value)) {
                                            this.setState({ userPhone: value });
                                        }
                                    }}
                                    onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={50} />
                                <input type="email" placeholder="Email" className="input-field" value={userEmail}
                                    onChange={(e) =>
                                        this.setState({ userEmail: e.target.value })
                                    }
                                    onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={50} />

                                <div className="password-container">
                                    <input
                                        type={is_showpass ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => this.setState({ password: e.target.value })}
                                        onKeyDown={(e) => this.handleKeyDown(e)}
                                        maxLength={25}
                                        placeholder="Password"
                                        className="input-field"
                                    />
                                    <i
                                        className={`fa ${is_showpass ? "fa-eye-slash" : "fa-eye"} show-password`}
                                        onClick={() =>
                                            this.setState((prevState) => ({ is_showpass: !prevState.is_showpass }))
                                        }
                                    ></i>
                                </div>
                                <button className="login-button"
                                    onClick={(e) => {
                                        if (this.state.isCommingSoon) {
                                            this.handleSubmit(e)
                                        } else {
                                            this.getCountDownDate(e)
                                        }
                                    }}
                                >Sign Up</button>

                                <a className="forgot-password" onClick={() => this.navigateLogIn()}>Already a User?</a>

                                {/* <ul className="ul_line">
                                    <li className="sub-menu-item" ><a href="#">or Continue with</a></li>
                                </ul>

                                <div className="social-buttons">
                                    <button className="google-login">
                                        <img src="img/google_img.png" />{""}
                                        Google
                                    </button>
                                    <button className="facebook-login">
                                        <img src="img/linkedin_img.png" />{""}
                                        LinkedIn
                                    </button>
                                </div> */}

                                <button class="btn btn-primary w-100 mt-4 py-2" onClick={() => this.navigateWebsite()}> Go to Website &nbsp; <i class="fa fa-long-arrow-right"></i></button>
                            </div>


                            {/* <div className="banner-section">
                                <div className="banner_inner_section">
                                    <h3>Inspiring Excellence, Celebrating Global Achievements</h3>
                                    <img src="img/login_img_boy.png" alt="Celebrating Achievements" className="banner-image" />
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <Modal show={this.state.isOpen2} size="lg" >
                        <Modal.Body className="pb-2 pt-2"
                            style={{
                                backgroundImage: 'url("../static/images/login-page-bg.jpg")',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}
                        >
                            <span
                                className="pop-close"
                                onClick={() => this.setState({ isOpen2: false }, () => {
                                    const { intervalId } = this.state;
                                    if (intervalId) {
                                        clearInterval(intervalId); // Stop the timer
                                        this.setState({ intervalId: null }); // Reset the interval ID
                                    }
                                })}
                            >
                                X
                            </span>
                            <div className="container text-center p-4">
                                <img
                                    src="../static/images/pop-logo.png"
                                    alt="logo"
                                    className="image timer-pop"
                                />
                                <h2 className="py-5 text-center com-soon-tag">Coming Soon</h2>
                                <h5 className="timer-pop-text com-soon">
                                    The sign up will start on 21<sup>st</sup> February 2025 at 12:00
                                    noon (IST)
                                </h5>
                                <h5 className="pt-3  timer-pop-text com-soon">
                                    The sign up will be on first come first basis.
                                </h5>
                                <div className="countdown-out mt-5">
                                    <div class="countdown">
                                        <div>
                                            <span id="days">{timeLeft.days}</span>
                                            <small>Days</small>
                                        </div>
                                        <div>
                                            <span id="hours">{timeLeft.hours}</span>
                                            <small>Hours</small>
                                        </div>
                                        <div>
                                            <span id="minutes">{timeLeft.minutes}</span>
                                            <small>Minutes</small>
                                        </div>
                                        <div>
                                            <span id="seconds">{timeLeft.seconds}</span>
                                            <small>Seconds</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </>
            </>
        );

    }


}

export default withRouter(connect(null, { signUp_action, getCurrentAwardDetails_action })(SignUp));
